import { compile, type MessageCompiler } from '@intlify/core-base'

export const messageCompiler: MessageCompiler = (message, context) => {
  const options = {
    ...context,
    onError: (error: SyntaxError) => {
      throw error
    },
  }

  try {
    return compile(message, options)
  } catch (error) {
    // don't let malformed translations crash FE rendering
    // eslint-disable-next-line no-console
    console.warn(
      'Invalid translation',
      { message, locale: context.locale, key: context.key },
      error,
    )
  }

  return compile(context.key, options)
}
